import { Component, Input, type OnInit } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { AbstractControl } from '@angular/forms'
import { selectAvailableTaskAssignees } from '@tv3/store/task/task.selectors'

@Component({
  selector: 'app-task-assignee-select',
  templateUrl: './task-assignee-select.component.html',
  styleUrls: ['./task-assignee-select.component.scss'],
})
export class TaskAssigneeSelectComponent implements OnInit {
  @Input() ctrl: AbstractControl

  @Input() placeholder = $localize`Assignees`
  @Input() multiple = true
  @Input() showLabel = true

  items$ = this.store.pipe(select(selectAvailableTaskAssignees))

  constructor(private store: Store<any>) {}

  ngOnInit(): void {}
}
